import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ActionIconsData } from './action-icons.model';
import {
  ConfigAssetLoaderService,
  User,
  AuthService,
} from '@icullen/api/shared';

@Component({
  selector: 'document-action-icons',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './action-icons.component.html',
  styleUrls: ['./action-icons.component.scss'],
})
export class ActionIconsComponent implements OnInit {
  @Input() data: ActionIconsData;

  @Output() favoriteChanged = new EventEmitter<boolean>();

  @Output() pdfPrintButtonClicked = new EventEmitter<string>();

  // @Output() editDocumentClicked = new EventEmitter<boolean>();

  currentUser: User;

  constructor(
    private configService: ConfigAssetLoaderService,
    private authService: AuthService
  ) {
    this.currentUser = this.authService.getCurrentUser();
  }

  ngOnInit(): void {}

  getMailToAddress(email: string) {
    return (
      'mailto:' +
      email +
      '?Subject=Question%20About%20Document%20' +
      this.data.uniqueNumber
    );
  }

  generatePdfClicked() {
    this.pdfPrintButtonClicked.emit('pdfDocClick');
  }

  printDocClicked() {
    this.pdfPrintButtonClicked.emit('printDocClick');
  }

  onFavoriteChanged(newState) {
    this.favoriteChanged.emit(newState);
  }

  getDocumentCorrectionUrl() {
    if (this.data.canCorrectDocument) {
      return (
        this.configService.getConfig().cmsWebappBaseUrl +
        'admin.html#/correct/' +
        this.data.docId
      );
    }
    return '#';
  }

  getPdfUrl(): string {
    if (this.data.documentType === 'BIG5_SECTION') {
      let uniqueNumberWithUuids = this.data.uniqueNumber;
      let uniqueNumber = uniqueNumberWithUuids.slice(0, 14);
      let uuids = uniqueNumberWithUuids.split('_');
      let sections = '';
      // for (let i = 1; i < uuids.length; i++) {
      //     sections = sections + 'section='+ uuids[i] + '&';
      // }
      uuids
        .slice(1)
        .forEach((uuid) => (sections = sections + 'section=' + uuid + '&'));
      let PdfUrl = `/product/documents/countryreport/pdf?${sections}uniqueNumber=${uniqueNumber}&orderBy=country`;
      return PdfUrl;
    } else {
      return `/product/pdf/${this.data.uniqueNumber}`;
    }
  }
}
